<form (ngSubmit)="onApplyFilters()" novalidate [formGroup]="filterForm">
	<div class="search-filter" [ngClass]="{ isModal: isModal }">
		<ng-container *ngIf="!isModal">
			<button
				class="button-search"
				[trackClick]="linkType.SEARCH_FILTER_TOGGLE_MOBILE"
				(click)="onToggleModal()"
				type="button"
				*ngIf="hideFields"
			>
				{{ 'search.filters.buttons.filter' | translate }} <i class="fal fa-filter"></i>
			</button>
		</ng-container>

		<ng-container *ngIf="!hideFields">
			<div class="search-filter__content">
				<app-group-button
					formControlName="saleLeaseOptions"
					[options]="saleLeaseOptions"
					[isVariant]="true"
				></app-group-button>

				<app-location-picker
					[locationCity]="locationCity"
					[locationState]="locationState"
					[latitude]="latitude"
					[longitude]="longitude"
					[locationRadius]="locationRadius"
					[locationLabel]="locationLabel"
					[appearance]="'outline'"
					[isOutLabel]="true"
					(selectionChange)="onLocationChanged($event)"
					(cleared)="onLocationCleared()"
				></app-location-picker>

				<app-filter-multi-select
					[appearance]="'outline'"
					[labelKey]="'search.filters.propertyTypes.title'"
					[placeholderKey]="'searchProperties.filters.selectOptions'"
					[optionLabelPrefix]="'propertyTypeOptions.'"
					[options]="propertyTypes"
					formControlName="propertyType"
					(ngModelChange)="onFilterChanged('propertyType', $event)"
				></app-filter-multi-select>

				<app-filter-multi-select
					[appearance]="'outline'"
					[labelKey]="'search.filters.propertySubtypes.title'"
					[placeholderKey]="'searchProperties.filters.selectOptions'"
					[optionLabelPrefix]="'propertySubTypeOptions.'"
					[options]="propertySubtypes"
					formControlName="propertySubTypes"
					(ngModelChange)="onFilterChanged('propertySubTypes', $event)"
				></app-filter-multi-select>

				<div class="relative">
					<div class="label-default" translate>search.filters.price.title</div>
					<div class="range-fields">
						<div class="range-fields__item">
							<app-non-negative-number-input
								(inputBlur)="onFilterChanged('priceRangeMin')"
								formControlName="priceRangeMin"
								[formatThousands]="true"
								[placeholderKey]="'search.filters.price.minimum'"
								[hasError]="filterForm.get('priceRangeMin')?.hasError('priceTooLow')"
							></app-non-negative-number-input>
						</div>
						<div class="range-fields__divider"><div class="input-text-divider"></div></div>
						<div class="range-fields__item">
							<app-non-negative-number-input
								(inputBlur)="onFilterChanged('priceRangeMax')"
								formControlName="priceRangeMax"
								[formatThousands]="true"
								[placeholderKey]="'search.filters.price.maximum'"
								[hasError]="filterForm.get('priceRangeMax')?.hasError('priceTooHigh')"
							></app-non-negative-number-input>
						</div>
					</div>
				</div>

				<div class="relative">
					<div class="label-default" translate>search.filters.size.title</div>
					<div class="range-fields">
						<div class="range-fields__item">
							<app-non-negative-number-input
								formControlName="minLivingArea"
								[placeholderKey]="'search.filters.size.minimum'"
								[suffixKey]="'sqft'"
							></app-non-negative-number-input>
						</div>
						<div class="range-fields__divider"><div class="input-text-divider"></div></div>
						<div class="range-fields__item">
							<app-non-negative-number-input
								formControlName="maxLivingArea"
								[placeholderKey]="'search.filters.size.maximum'"
								[suffixKey]="'sqft'"
							></app-non-negative-number-input>
						</div>
					</div>
				</div>

				<app-bed-bath-select
					type="bedrooms"
					[customValues]="itemsBedroom"
					(valueSelected)="onFilterChanged('minBedrooms', $event)"
					formControlName="minBedrooms"
					class="bed-bath-select"
					appearance="fill"
					[label]="'search.filters.bedroom.title' | translate"
					[isColorVariant]="true"
				></app-bed-bath-select>

				<app-bed-bath-select
					type="bathrooms"
					[customValues]="itemsBathroom"
					(valueSelected)="onFilterChanged('minBathrooms', $event)"
					formControlName="minBathrooms"
					class="bed-bath-select"
					appearance="fill"
					[label]="'search.filters.bathroom.title' | translate"
					[isColorVariant]="true"
				></app-bed-bath-select>

				<div class="block">
					<div class="label-default" translate>search.filters.daysOnMarket.title</div>

					<mat-form-field appearance="outline" class="mat-select-helper">
						<mat-select
							formControlName="daysOnMarket"
							[placeholder]="'search.filters.daysOnMarket.placeholder' | translate"
						>
							<mat-option *ngFor="let option of daysOnMarketOptions" [value]="option">
								{{ 'daysOnMarketOptions.' + option | translate }}
							</mat-option>
						</mat-select>
					</mat-form-field>
				</div>

				<div class="relative">
					<div class="label-default">
						{{ 'search.filters.yearBuilt.title' | translate }}
					</div>
					<div class="range-fields">
						<div class="range-fields__item">
							<app-non-negative-number-input
								(inputBlur)="onFilterChanged('minYearBuilt')"
								formControlName="minYearBuilt"
								[formatThousands]="false"
								[placeholderKey]="'search.filters.yearBuilt.minimum'"
								[hasError]="filterForm.get('minYearBuilt')?.hasError('yearBuiltTooLow')"
							></app-non-negative-number-input>
						</div>
						<div class="range-fields__divider"></div>
						<div class="range-fields__item">
							<app-non-negative-number-input
								(inputBlur)="onFilterChanged('maxYearBuilt')"
								formControlName="maxYearBuilt"
								[formatThousands]="false"
								[placeholderKey]="'search.filters.yearBuilt.maximum'"
								[hasError]="filterForm.get('maxYearBuilt')?.hasError('yearBuiltTooHigh')"
							></app-non-negative-number-input>
						</div>
					</div>
				</div>

				<app-real-estate-features-multi-select
					[appearance]="'outline'"
					[entityType]="entityType"
					[entityId]="entityId"
					[labelKey]="'search.filters.features.title'"
					[placeholderKey]="'searchProperties.filters.selectOptions'"
					formControlName="features"
				></app-real-estate-features-multi-select>
			</div>

			<div class="search-filter__footer">
				<hr class="search-filter__divider" />
				<div class="row">
					<div class="col-6">
						<button type="submit" class="button-search" [disabled]="isLoading">
							{{ 'search.filters.buttons.filter' | translate }}
							<i class="fal fa-spinner fa-spin" *ngIf="isLoading"></i>
						</button>
					</div>
					<div class="col-6">
						<button type="button" class="button-search outline" (click)="onClearFilters()">
							{{ 'search.filters.buttons.clearAll' | translate }}
						</button>
					</div>
				</div>
			</div>
		</ng-container>
	</div>
</form>
